import { Dispatch, SetStateAction } from "react";
import { WorkTitle } from "./workDetailPage/WorkTitle";
import NextItem from "./components/NextItem";
import BackButton from "./components/BackButton";
import { WorkTextSection } from "./workDetailPage/WorkTextSection";
import { MainImage } from "./workDetailPage/WorkMainImage";
import Navigator from './components/Navigation';

import mainImage from './image/works/work11MainImage.webp';
import { useMetaTags } from './utils/useMetaTags';
import ProtectedPage from './components/ProtectedPage';
import { hashPasswordsFromEnv } from './utils/passwordUtils';

//missionUX

function Work11(props: {
    activeNav: number, 
    setActiveNav: Dispatch<SetStateAction<number>>,
  }) {
      useMetaTags({
        title: 'Improvement the mission contents UX - Lynkim',
        description: 'Improving content UX to increase mission completion rate.',
        image: '/ogimage.png',
      });
      
      // 비밀번호는 .env.local의 REACT_APP_WORK_PASSWORD에 저장 (gitignored)
      const password = hashPasswordsFromEnv(process.env.REACT_APP_WORK_PASSWORD);
      
      return (
        // <ProtectedPage password={password} description="이 페이지는 비밀번호로 잠겨있어요">
        <>
        <Navigator activeNav={props.activeNav} setActiveNav={props.setActiveNav} />
        <div className='fadeIn '>
          <WorkTitle 
            title={'Improvement the mission contents UX'} 
            description={'Improving content UX to increase mission completion rate.'} 
            team={'Minding'} 
            role={'Service Planning, UXUI Design'} 
            period={'2019.01. - 2019.06.'}
            titleKo={'미션 콘텐츠 UX 개선'}
            descriptionKo={'미션 완료율을 높이기 위해 콘텐츠 UX를 개선했습니다.'}
            teamKo={'마인딩(Minding)'}
            roleKo={'서비스 기획, UXUI 디자인'}
            showButton={true}
            buttonLabel="View Project"
            buttonHref="https://www.figma.com/proto/iQ9Tgs7kQgjO6waM0oealt/Portfolio_lynkim?page-id=559%3A204&node-id=559-205&p=f&viewport=383%2C1421%2C0.31&t=4huYVHl4a2DTxKcO-1&scaling=min-zoom&content-scaling=fixed&starting-point-node-id=559%3A205"/>
        </div>
        <MainImage image={mainImage}/>
        <BackButton/>
        <div style={{ height: "400px" }} />
        </>
        // </ProtectedPage>
      )
  }
  
  export default Work11;